{{#if hint}}
<p class="tool-hint">
  {{ hint }}
</p>
{{/if}}
